import { useAppSelector } from '@/app/hooks';
import Basemap from '@arcgis/core/Basemap';
import { ActionIcon } from "@mantine/core";
import { IconMap } from "@tabler/icons-react";
import { webMap } from '../pqMapSlice';


const BasemapToggle: React.FC = () => {
    const currentWebMap = useAppSelector(webMap);

    const toggleBasemap = () => {
        if (currentWebMap) {
            const basemap = currentWebMap.basemap?.title === 'Topographic' ? Basemap.fromId('hybrid') : Basemap.fromId('topo')
            currentWebMap.basemap = basemap;
        }
    }
    return (
        <ActionIcon variant='filled' color='black' size='lg' radius='xl' aria-label='Change Basemap' style={{ position: 'absolute', top: 'calc(env(safe-area-inset-top, 0px) + 70px)', right: 20 }} onClick={toggleBasemap} >
            <IconMap color='#B3B3B3' style={{ width: '70%', height: '70%', marginRight: 2 }} stroke={2} />
        </ActionIcon>
    );
}

export default BasemapToggle;    